var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 0H9.375C4.19733 0 0 4.19733 0 9.375V30.625C0 35.8027 4.19733 40 9.375 40H30.625C35.8027 40 40 35.8027 40 30.625V9.375C40 4.19733 35.8027 0 30.625 0Z",
    fill: "#242938"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 22.9611C21.6101 22.9611 22.9151 21.6559 22.9151 20.0461C22.9151 18.4363 21.6101 17.1311 20.0001 17.1311C18.3901 17.1311 17.0851 18.4363 17.0851 20.0461C17.0851 21.6559 18.3903 22.9611 20.0001 22.9611Z",
    fill: "#00D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 14.1191C23.9141 14.1191 27.5498 14.6807 30.2912 15.6246C33.5942 16.7616 35.625 18.4852 35.625 20.046C35.625 21.6724 33.4728 23.5035 29.9258 24.6787C27.2442 25.5671 23.7155 26.0309 20.0003 26.0309C16.1912 26.0309 12.5842 25.5955 9.87234 24.6688C6.44141 23.4962 4.375 21.6415 4.375 20.046C4.375 18.4979 6.31406 16.7876 9.57062 15.6523C12.3222 14.6929 16.0477 14.1191 19.9997 14.1191H20.0003Z",
    stroke: "#00D8FF",
    strokeWidth: 0.556938
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8408 17.0997C16.7961 13.7094 19.0987 10.8403 21.2859 8.93719C23.9209 6.6439 26.4287 5.74578 27.7806 6.52531C29.1895 7.33781 29.7006 10.1172 28.9467 13.7769C28.3772 16.5436 27.0156 19.832 25.1595 23.0505C23.2566 26.3502 21.0777 29.2573 18.9203 31.143C16.1905 33.5292 13.5512 34.3928 12.1692 33.5958C10.8281 32.823 10.3153 30.2884 10.9587 26.9002C11.5023 24.0372 12.8666 20.5233 14.8402 17.0997H14.8408Z",
    stroke: "#00D8FF",
    strokeWidth: 0.556938
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8456 23.0592C12.8848 19.6726 11.5498 16.2442 10.9926 13.3988C10.3219 9.97056 10.7961 7.34946 12.1469 6.56759C13.5545 5.75259 16.2175 6.6979 19.0115 9.17884C21.124 11.0545 23.2933 13.8759 25.1547 17.0912C27.0631 20.3877 28.4934 23.7276 29.0498 26.5382C29.7539 30.0951 29.184 32.8127 27.8033 33.612C26.4636 34.3876 24.0119 33.5665 21.3976 31.3168C19.1889 29.4162 16.8258 26.4795 14.8456 23.0592Z",
    stroke: "#00D8FF",
    strokeWidth: 0.556938
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.79e67f1ed3716b7d67743c96719e1627.svg";
export { ForwardRef as ReactComponent };